{
  "rk.datepicker.clear": "清除",
  "rk.datepicker.confirm": "确定",
  "rk.datepicker.selectDate": "选择日期",
  "rk.datepicker.selectRange": "选择日期范围",
  "rk.datepicker.time": "时间",
  "rk.error.unknown": "未知错误",
  "rk.json.tableAria": "JSON 数据表",
  "rk.multiSelect.noOptions": "无可用选项。",
  "rk.multiSelect.select": "选择...",
  "rk.multiSelect.selected": "已选 {{count}} 项",
  "rk.print.action": "打印",
  "rk.print.all": "打印全部数据",
  "rk.print.options.confirm": "打印",
  "rk.print.options.title": "打印选项",
  "rk.print.selected": "打印选中数据",
  "rk.print.sheet.title": "{{resource}} — 打印稿",
  "rk.print.tooManyRows": "要打印的行数过多（超过 {{limit}} 行），请先缩小范围。",
  "rk.print.window.blocked": "浏览器拦截了打印窗口。请为本站点允许弹出窗口后重新打印。",
  "rk.print.window.hint": "打印前请在浏览器打印设置中关闭「页眉和页脚」，并将「边距」保持为「默认」——纸张边距由本页自带。",
  "rk.print.window.preparing": "正在生成打印内容…",
  "rk.query.addFilter": "筛选条件",
  "rk.query.cancel": "取消",
  "rk.query.clearSearch": "清除搜索",
  "rk.query.removeFilter": "移除筛选",
  "rk.query.searchChip": "搜索：{{term}}",
  "rk.query.searchChipTitle": "点击可修改搜索词：{{term}}",
  "rk.query.searchPlaceholder": "输入关键词搜索",
  "rk.query.selectMultiple": "选择多个...",
  "rk.resource.actionCompleted": "操作完成",
  "rk.resource.actionFailed": "{{name}} 失败",
  "rk.resource.conditionsMerged": "同一字段（{{fields}}）上的多个筛选条件已合并为一条——下方列表按合并后的条件过滤。",
  "rk.resource.conditionsOverridden": "同一字段（{{fields}}）上的多个筛选条件无法合并，仅最后一条生效——下方列表忽略了较早的那些条件。",
  "rk.resource.confirmProceed": "确定要继续吗？",
  "rk.resource.create": "创建{{name}}",
  "rk.resource.createTitle": "创建{{name}}",
  "rk.resource.created": "已创建",
  "rk.resource.createdSuccess": "{{name}}创建成功",
  "rk.resource.creating": "创建中...",
  "rk.resource.deleteConfirmMessage": "确定要删除此{{name}}吗？此操作不可撤销。",
  "rk.resource.deleteConfirmTitle": "删除{{name}}",
  "rk.resource.deleteFailed": "删除失败",
  "rk.resource.deleted": "已删除",
  "rk.resource.deletedSuccess": "{{name}}删除成功",
  "rk.resource.details": "详情",
  "rk.resource.discardConfirm": "放弃",
  "rk.resource.discardMessage": "有未保存的更改。确定不保存就关闭吗？",
  "rk.resource.discardTitle": "放弃更改？",
  "rk.resource.editField": "编辑{{field}}",
  "rk.resource.enterField": "请输入{{field}}",
  "rk.resource.errorLoading": "加载{{name}}时出错",
  "rk.resource.filtersDropped": "部分筛选条件（{{fields}}）服务端不支持，未生效——下方列表并未按这些条件过滤。",
  "rk.resource.keepEditing": "继续编辑",
  "rk.resource.loadingRecord": "加载记录中...",
  "rk.resource.openFullPage": "打开完整页面",
  "rk.resource.other": "其他",
  "rk.resource.proceedWith": "确认对 {{count}} 项执行操作？",
  "rk.resource.quickFilter.all": "全部",
  "rk.resource.recordNotFound": "未找到记录",
  "rk.resource.relation.clear": "清除{{field}}",
  "rk.resource.relation.noMatches": "无匹配结果",
  "rk.resource.rowActionsLabel": "操作",
  "rk.resource.selectField": "请选择{{field}}",
  "rk.resource.somethingWrong": "出现了错误",
  "rk.resource.tabHasErrors": "此标签页有错误",
  "rk.resource.tryAgain": "重试",
  "rk.resource.unexpectedError": "渲染此组件时发生了意外错误。",
  "rk.resource.updated": "已更新",
  "rk.resource.updatedSuccess": "{{name}}更新成功",
  "rk.resource.validation.invalidDate": "请输入有效日期。",
  "rk.resource.validation.invalidEnum": "请选择有效选项。",
  "rk.resource.validation.invalidField": "请输入有效值。",
  "rk.resource.validation.invalidJson": "请输入有效的 JSON。",
  "rk.resource.validation.invalidNumber": "请输入有效数字。",
  "rk.resource.validation.recordLevel": "无法保存：{{message}}",
  "rk.resource.validation.required": "此项为必填。",
  "rk.schema.invalidJson": "无效 JSON",
  "rk.schema.items": "{{count}} 项",
  "rk.schema.keys": "{{count}} 个字段",
  "rk.sheet.close": "关闭",
  "rk.table.clearFilters": "清除筛选",
  "rk.table.columns": "列",
  "rk.table.export": "导出",
  "rk.table.exportAllFailed": "导出失败",
  "rk.table.exportCsvAll": "导出全部数据 (CSV)",
  "rk.table.exportCsvSelected": "导出选中数据 (CSV)",
  "rk.table.exportTooLarge": "数据量过大（超过 {{limit}} 行），已中止导出；请收窄筛选后重试。",
  "rk.table.goToFirstPage": "跳到第一页",
  "rk.table.goToLastPage": "跳到最后一页",
  "rk.table.goToNextPage": "下一页",
  "rk.table.goToPrevPage": "上一页",
  "rk.table.layoutCards": "卡片视图",
  "rk.table.layoutTable": "表格视图",
  "rk.table.loading": "加载中...",
  "rk.table.noMatchingResults": "没有匹配的结果",
  "rk.table.noResultsFound": "未找到结果",
  "rk.table.openRecord": "查看详情",
  "rk.table.pageOf": "{{page}} / {{total}}",
  "rk.table.perPageOption": "{{count}} 条/页",
  "rk.table.rowsPerPage": "每页显示",
  "rk.table.rowsSelected": "已选 {{count}} 行",
  "rk.table.selectAll": "全选",
  "rk.table.selectRow": "选择行",
  "rk.table.toggleColumnsLabel": "切换列显隐",
  "rk.table.totalRecords_one": "共 {{total}} 条",
  "rk.table.totalRecords_other": "共 {{total}} 条",
  "rk.ui.cancel": "取消",
  "rk.ui.copied": "已复制",
  "rk.ui.copy": "复制",
  "rk.ui.copyFailed": "复制失败",
  "rk.ui.copyId": "复制 ID",
  "rk.ui.create": "创建",
  "rk.ui.delete": "删除",
  "rk.ui.edit": "编辑",
  "rk.ui.error": "出现错误",
  "rk.ui.idCopied": "ID 已复制",
  "rk.ui.loading": "加载中...",
  "rk.ui.no": "否",
  "rk.ui.retry": "重试",
  "rk.ui.save": "保存",
  "rk.ui.saving": "保存中…",
  "rk.ui.search": "搜索",
  "rk.ui.yes": "是"
}
